import { isAprimo, attachAprimoVideo, attachHlsVideo } from '../../js/parts/aprimo-video.js';
import { bindPlayPauseIcon } from '../../js/parts/video-play-state.js';

jQuery(document).ready(function ($) {
	// Zoom state variable
	let isZoomed = false;

	// MOBILE: Pinch-to-zoom state variables
	let isPinching = false;
	let initialPinchDistance = 0;
	let currentScale = 1;
	let pinchOriginX = 50;
	let pinchOriginY = 50;
	let $pinchTarget = null;
	const MIN_SCALE = 1;
	const MAX_SCALE = 2.5;

	// Early return if gallery elements don't exist
	if (!$('.gallery-thumbs').length) {
		return;
	}

	const $galleryThumbs = $('.gallery-thumbs');
	let thumbsClassAdded = false;

	// Function to calculate thumb height and add appropriate class
	function updateThumbsClass() {
		if (thumbsClassAdded) return;

		let galleryThumbHeight = 0;
		$galleryThumbs.find('.swiper-slide').each(function() {
			galleryThumbHeight += $(this).outerHeight(true);
		});

		const screenHeight = window.innerHeight;
		if (galleryThumbHeight > screenHeight) {
			$galleryThumbs.addClass('justify-child-initial');
		} else {
			$galleryThumbs.addClass('justify-child-center');
		}
		thumbsClassAdded = true;
	}

	const galleryThumbs = new Swiper('.gallery-thumbs', {
		spaceBetween: 0,
		slidesPerView: "auto",
		freeMode: true,
		watchSlidesProgress: true,
		direction: "vertical",
	});

	// Get DOM element references to prevent other Swipers from targeting them
	const galleryTopEl = document.querySelector('.gallery-top');
	const galleryTopPaginationEl = document.querySelector('.gallery-top-pagination');

	// Early return if lightbox gallery doesn't exist
	if (!galleryTopEl) {
		return;
	}

	// Remove generic swiper-pagination class to prevent other Swipers from targeting it
	if (galleryTopPaginationEl) {
		galleryTopPaginationEl.classList.remove('swiper-pagination');
	}

	const galleryTop = new Swiper(galleryTopEl, {
		spaceBetween: 10,
		loop: false,
		navigation: {
			nextEl: '.gallery-top .swiper-button-next',
			prevEl: '.gallery-top .swiper-button-prev',
		},
		pagination: {
			el: galleryTopPaginationEl,
			type: "fraction"
		},
		thumbs: {
			swiper: galleryThumbs,
		},
		on: {
			init: function (swiper) {
				// Mark video slides with special class for pagination styling
				if (swiper.pagination && swiper.pagination.bullets) {
					swiper.slides.forEach((slide, index) => {
						const hasVideo = !!$(slide).find('video').length;
						const bullet = swiper.pagination.bullets[index];
						if (hasVideo && bullet) {
							$(bullet).addClass('has-video');
						}
					});
				}
			},
			slideChange: function () {
				// Reset zoom when changing slides
				resetZoom();
			},
		},
	});

	// Reset zoom function
	function resetZoom() {
		isZoomed = false;
		isTouchDragging = false;
		touchOriginX = 50;
		touchOriginY = 50;
		// Reset pinch-to-zoom state
		isPinching = false;
		currentScale = 1;
		initialPinchDistance = 0;
		$pinchTarget = null;
		$('.gallery-top .swiper-slide img, .gallery-top .swiper-slide video').css({
			'transform': 'scale(1)',
			'transform-origin': 'center center',
			'cursor': 'zoom-in'
		});
		$('.gallery-top .swiper-slide').removeClass('is-zoomed');
		// Re-enable swiper swiping
		if (galleryTop && typeof galleryTop.allowTouchMove !== 'undefined') {
			galleryTop.allowTouchMove = true;
		}
	}

	// Throttle function for performance
	function throttle(func, limit) {
		let inThrottle;
		return function(e) {
			const context = this;
			if (!inThrottle) {
				func.call(context, e);
				inThrottle = true;
				setTimeout(function() {
					inThrottle = false;
				}, limit);
			}
		};
	}

	// Handle click on lightbox images to toggle zoom (DESKTOP/TABLET ONLY)
	$(document).on('click', '.gallery-top .swiper-slide img, .gallery-top .swiper-slide video', function (e) {
		// Only allow tap-to-zoom on desktop/tablet (768px+)
		if (window.outerWidth <= 768) {
			return;
		}

		// If we were touch dragging, don't toggle zoom
		if (isTouchDragging) {
			return;
		}

		const $media = $(this);
		const $slide = $media.closest('.swiper-slide');

		if (!isZoomed) {
			// Zoom in (2x magnification)
			isZoomed = true;

			// Calculate click position for transform origin
			const rect = this.getBoundingClientRect();
			const x = ((e.clientX - rect.left) / rect.width) * 100;
			const y = ((e.clientY - rect.top) / rect.height) * 100;

			// Store for touch panning
			touchOriginX = x;
			touchOriginY = y;

			$media.css({
				'transform': 'scale(2)',
				'transform-origin': x + '% ' + y + '%',
				'cursor': 'zoom-out'
			});
			$slide.addClass('is-zoomed');

			// Disable swiper swiping when zoomed
			if (galleryTop && typeof galleryTop.allowTouchMove !== 'undefined') {
				galleryTop.allowTouchMove = false;
			}
		} else {
			// Zoom out
			resetZoom();
		}
	});

	// DESKTOP: Handle mouse move for panning when zoomed (original behavior)
	$(document).on('mousemove', '.gallery-top .swiper-slide.is-zoomed img, .gallery-top .swiper-slide.is-zoomed video', throttle(function (e) {
		if (!isZoomed) return;

		const rect = this.getBoundingClientRect();
		const x = ((e.clientX - rect.left) / rect.width) * 100;
		const y = ((e.clientY - rect.top) / rect.height) * 100;

		$(this).css({
			'transform-origin': x + '% ' + y + '%'
		});
	}, 16)); // ~60fps

	// MOBILE: Touch event handling for zoom panning
	let isTouchDragging = false;
	let touchStartX = 0;
	let touchStartY = 0;
	let touchOriginX = 50;
	let touchOriginY = 50;
	let $touchTarget = null;

	// Touch start - capture initial position
	$(document).on('touchstart', '.gallery-top .swiper-slide.is-zoomed img, .gallery-top .swiper-slide.is-zoomed video', function (e) {
		if (!isZoomed) return;

		const touch = e.originalEvent.touches[0];
		touchStartX = touch.clientX;
		touchStartY = touch.clientY;
		$touchTarget = $(this);
		isTouchDragging = false; // Will be set true on move
	});

	// Touch move - pan the zoomed image
	$(document).on('touchmove', '.gallery-top .swiper-slide.is-zoomed img, .gallery-top .swiper-slide.is-zoomed video', throttle(function (e) {
		if (!isZoomed || !$touchTarget) return;

		const touch = e.originalEvent.touches[0];
		const deltaX = touchStartX - touch.clientX;
		const deltaY = touchStartY - touch.clientY;

		// Only start dragging if moved more than 5 pixels
		if (!isTouchDragging && (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5)) {
			isTouchDragging = true;
		}

		if (!isTouchDragging) return;

		e.preventDefault(); // Prevent page scroll while panning

		const rect = this.getBoundingClientRect();

		// Calculate movement delta as percentage of image size
		const deltaXPercent = (deltaX / rect.width) * 100;
		const deltaYPercent = (deltaY / rect.height) * 100;

		// Update origin based on swipe direction
		let newOriginX = touchOriginX + deltaXPercent;
		let newOriginY = touchOriginY + deltaYPercent;

		// Clamp values between 0 and 100
		newOriginX = Math.max(0, Math.min(100, newOriginX));
		newOriginY = Math.max(0, Math.min(100, newOriginY));

		$(this).css({
			'transform-origin': newOriginX + '% ' + newOriginY + '%'
		});

		// Update start position for continuous panning
		touchStartX = touch.clientX;
		touchStartY = touch.clientY;
		touchOriginX = newOriginX;
		touchOriginY = newOriginY;
	}, 16)); // ~60fps

	// Touch end - stop panning
	$(document).on('touchend touchcancel', '.gallery-top .swiper-slide.is-zoomed img, .gallery-top .swiper-slide.is-zoomed video', function () {
		$touchTarget = null;
		// Small delay to prevent click from firing after drag
		if (isTouchDragging) {
			setTimeout(function() {
				isTouchDragging = false;
			}, 50);
		}
	});

	// MOBILE: Pinch-to-zoom functionality (768px and below)
	// Calculate distance between two touch points
	function getPinchDistance(touches) {
		return Math.hypot(
			touches[0].clientX - touches[1].clientX,
			touches[0].clientY - touches[1].clientY
		);
	}

	// Calculate center point between two touches
	function getPinchCenter(touches, rect) {
		const centerX = (touches[0].clientX + touches[1].clientX) / 2;
		const centerY = (touches[0].clientY + touches[1].clientY) / 2;
		return {
			x: ((centerX - rect.left) / rect.width) * 100,
			y: ((centerY - rect.top) / rect.height) * 100
		};
	}

	// Pinch start - detect two fingers and initialize
	$(document).on('touchstart', '.gallery-top .swiper-slide img, .gallery-top .swiper-slide video', function (e) {
		// Only enable pinch-to-zoom on mobile (768px and below)
		if (window.outerWidth > 768) {
			return;
		}

		const touches = e.originalEvent.touches;

		// Require exactly 2 fingers for pinch
		if (touches.length === 2) {
			e.preventDefault();
			isPinching = true;
			initialPinchDistance = getPinchDistance(touches);
			$pinchTarget = $(this);

			// Calculate pinch center for transform origin
			const rect = this.getBoundingClientRect();
			const center = getPinchCenter(touches, rect);
			pinchOriginX = center.x;
			pinchOriginY = center.y;

			// Store current scale if already zoomed
			if (!isZoomed) {
				currentScale = 1;
			}

			// Disable swiper swiping during pinch
			if (galleryTop && typeof galleryTop.allowTouchMove !== 'undefined') {
				galleryTop.allowTouchMove = false;
			}
		}
	});

	// Pinch move - calculate scale and apply transform
	$(document).on('touchmove', '.gallery-top .swiper-slide img, .gallery-top .swiper-slide video', function (e) {
		// Only enable pinch-to-zoom on mobile (768px and below)
		if (window.outerWidth > 768) {
			return;
		}

		const touches = e.originalEvent.touches;

		// Handle pinch gesture (2 fingers)
		if (isPinching && touches.length === 2 && $pinchTarget) {
			e.preventDefault();

			const currentDistance = getPinchDistance(touches);
			const scaleDelta = currentDistance / initialPinchDistance;

			// Calculate new scale based on pinch movement
			let newScale = currentScale * scaleDelta;

			// Clamp scale between min and max
			newScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));

			const $media = $pinchTarget;
			const $slide = $media.closest('.swiper-slide');

			// Apply the transform
			$media.css({
				'transform': 'scale(' + newScale + ')',
				'transform-origin': pinchOriginX + '% ' + pinchOriginY + '%',
				'cursor': newScale > 1 ? 'zoom-out' : 'zoom-in'
			});

			// Update zoom state
			if (newScale > 1) {
				if (!isZoomed) {
					isZoomed = true;
					$slide.addClass('is-zoomed');
				}
				// Update touch origin for panning after pinch
				touchOriginX = pinchOriginX;
				touchOriginY = pinchOriginY;
			} else {
				if (isZoomed) {
					isZoomed = false;
					$slide.removeClass('is-zoomed');
					// Re-enable swiper when fully zoomed out
					if (galleryTop && typeof galleryTop.allowTouchMove !== 'undefined') {
						galleryTop.allowTouchMove = true;
					}
				}
			}

			// Update for continuous pinching
			initialPinchDistance = currentDistance;
			currentScale = newScale;
		}
	});

	// Pinch end - finalize zoom state
	$(document).on('touchend touchcancel', '.gallery-top .swiper-slide img, .gallery-top .swiper-slide video', function (e) {
		// Only enable pinch-to-zoom on mobile (768px and below)
		if (window.outerWidth > 768) {
			return;
		}

		const touches = e.originalEvent.touches;

		// End pinch when less than 2 fingers remain
		if (isPinching && touches.length < 2) {
			isPinching = false;
			$pinchTarget = null;

			// If zoomed out completely, reset everything
			if (currentScale <= MIN_SCALE) {
				resetZoom();
				currentScale = 1;
			}
		}
	});

	// Reset zoom when closing lightbox
	$(document).on('click', '.lightbox-overlay', function () {
		resetZoom();
	});

	// Handle ESC key to close lightbox and reset zoom
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' || e.keyCode === 27) {
			const $lightbox = $('.lightbox-modal');
			if ($lightbox.hasClass('lightbox-show')) {
				$lightbox.removeClass('lightbox-show');
				$('body').removeClass('body-fixed');
			}
			// Always reset zoom on ESC (handles both zoomed state and lightbox close)
			if (isZoomed) {
				resetZoom();
			}
		}
	});

	// Only initialize mobile carousel if the element exists (mobile only)
	if ($('.product-gallery-carousel-mobile').length) {
		const mobileCarousel = new Swiper('.product-gallery-carousel-mobile', {
			spaceBetween: 10,
			loop: false,
			navigation: {
				nextEl: '.product-gallery-carousel-mobile .swiper-button-next',
				prevEl: '.product-gallery-carousel-mobile .swiper-button-prev',
			},
			pagination: {
				el: '.product-gallery-carousel-mobile .swiper-pagination',
				clickable: true,
			},
			thumbs: {
				swiper: galleryThumbs,
			},
			on: {
				init: function (swiper) {
					// Mark video slides with special class for pagination styling
					if (swiper.pagination && swiper.pagination.bullets) {
						swiper.slides.forEach((slide, index) => {
							const hasVideo = !!$(slide).find('video').length;
							const bullet = swiper.pagination.bullets[index];
							if (hasVideo && bullet) {
								$(bullet).addClass('has-video');
							}
						});
					}
				},
			},
		});
	}

	// Lightbox functionality for both desktop and mobile
	// if (window.outerWidth > 768) { // OLD: was desktop-only
	const $images = $('.product-gallery-container img, .product-gallery-container video');
	const $lightbox = $('.lightbox-modal');
	const $overlay = $('.lightbox-overlay');
	const $closeButton = $('.lightbox-close');
	const $body = $('body');

	// Desktop: click on images in flex gallery
	if (window.outerWidth > 768) {
		$images.on('click', function () {
			// activate current clicked slide in lightbox
			const $currentSlide = $(this);
			// get closest .gallery-image-wrapper
			const $galleryImageWrapper = $currentSlide.closest('.gallery-image-wrapper');

			if (galleryTop && typeof galleryTop.slideTo === 'function') {
				if ($galleryImageWrapper.length) {
					// OLD: let index = $galleryImageWrapper.index();
					let index = $galleryImageWrapper.data('index');
					index = parseInt(index, 10) + 1; // +1 because featured image is first in lightbox
					galleryTop.slideTo(index, 0);
				} else {
					galleryTop.slideTo(0, 0);
				}
			}

			$lightbox.addClass('lightbox-show');
			$body.addClass('body-fixed');
			updateThumbsClass();
		});
	} else {
		// Mobile: click on slides in mobile carousel
		// Use event delegation to handle clicks on swiper slides
		$(document).on('click', '.product-gallery-carousel-mobile .gallery-image-wrapper', function (e) {
			// Prevent opening lightbox if user is swiping (dragging)
			const swiper = document.querySelector('.product-gallery-carousel-mobile')?.swiper;
			if (swiper && swiper.animating) {
				return;
			}

			const $galleryImageWrapper = $(this);
			const index = parseInt($galleryImageWrapper.data('index'), 10) || 0;

			if (galleryTop && typeof galleryTop.slideTo === 'function') {
				galleryTop.slideTo(index, 0);
			}

			$lightbox.addClass('lightbox-show');
			$body.addClass('body-fixed');
			updateThumbsClass();
		});
	}

	// Lightbox close handlers (shared for both desktop and mobile)
	$overlay.on('click', function () {
		$lightbox.removeClass('lightbox-show');
		$body.removeClass('body-fixed');
		resetZoom();
	});

	$closeButton.on('click', function () {
		$lightbox.removeClass('lightbox-show');
		$body.removeClass('body-fixed');
		resetZoom();
	});
	// } // OLD: end of desktop-only block

	// Lazy-load the lightbox copies (Cloudflare and Aprimo). Every gallery video is rendered
	// 3 times (page gallery, lightbox slides, lightbox thumbnails); only the page copy should
	// load on page load. Moving the URL to data-lazy-video-url makes the initialisation loop
	// below skip these copies (it returns when data-video-url is missing); they are started
	// the first time the lightbox opens, and only the visible slide plays.
	const $lazyLightboxVideos = $lightbox.find('video[data-video-url]');
	let lightboxVideosStarted = false;

	$lazyLightboxVideos.each(function () {
		this.dataset.lazyVideoUrl = this.getAttribute('data-video-url');
		this.removeAttribute('data-video-url');
	});

	function playVisibleLightboxVideo() {
		const isOpen = $lightbox.hasClass('lightbox-show');
		const activeSlide = galleryTop && galleryTop.slides ? galleryTop.slides[galleryTop.activeIndex] : null;

		$lazyLightboxVideos.not('.product-video-thumb').each(function () {
			if (isOpen && activeSlide && activeSlide.contains(this)) {
				this.play().catch(function () {});
			} else if (!this.paused) {
				this.pause();
			}
		});
	}

	function startLightboxVideos() {
		if (lightboxVideosStarted) return;
		lightboxVideosStarted = true;

		$lazyLightboxVideos.each(function () {
			const video = this;
			const url = video.dataset.lazyVideoUrl;

			if (!url) return;

			video.setAttribute('data-video-url', url);

			// Thumbnails only show a frame; slides play when visible.
			const onReady = video.classList.contains('product-video-thumb') ? null : playVisibleLightboxVideo;

			if (isAprimo(url)) {
				attachAprimoVideo(video, url, { onReady: onReady });
			} else {
				attachHlsVideo(video, url, { onReady: onReady });
			}
		});
	}

	if ($lazyLightboxVideos.length && $lightbox.length) {
		new MutationObserver(function () {
			if ($lightbox.hasClass('lightbox-show')) {
				startLightboxVideos();
			}
			playVisibleLightboxVideo();
		}).observe($lightbox[0], { attributes: true, attributeFilter: ['class'] });

		if (galleryTop && typeof galleryTop.on === 'function') {
			galleryTop.on('slideChange', playVisibleLightboxVideo);
		}
	}

	$('.product-gallery-wrapper video').each(function () {
		const $video = $(this);
		const video = this;
		const videoUrl = $video.data('video-url');

		if (!videoUrl) return;

		// Aprimo MP4 / HLS. Cloudflare continues to the hls.js code below.
		if (isAprimo(videoUrl)) {
			const $aprimoActions    = $video.siblings('.video-actions');
			const aprimoMuteUnmute  = $aprimoActions.find('.video-mute-unmute').find('svg');

			attachAprimoVideo(video, videoUrl, {
				onReady: function () {
					video.autoplay = true;

					// Auto-play main video or all videos on mobile.
					// The play/pause icon follows the video's own events (bindPlayPauseIcon below).
					if ($video.hasClass('main-video') || window.outerWidth < 768) {
						video.play().catch(function (err) {
							console.warn('Auto-play was prevented:', err);
						});
					}

					// Video starts muted
					aprimoMuteUnmute.eq(0).show();
					aprimoMuteUnmute.eq(1).hide();
				}
			});
			return;
		}

		if (typeof Hls !== 'undefined' && Hls.isSupported()) {
			const hls = new Hls({
				enableWorker: true,
				lowLatencyMode: true,
				backBufferLength: 90
			});

			hls.loadSource(videoUrl);
			hls.attachMedia(video);

			// Set initial icon states for video controls
			const $actions    = $video.siblings('.video-actions');
			const play_pause  = $actions.find('.video-play-pause').find('svg');
			const mute_unmute = $actions.find('.video-mute-unmute').find('svg');

			hls.on(Hls.Events.MANIFEST_PARSED, function () {
				video.muted = true;
				video.loop = true;
				video.playsInline = true;
				video.autoplay = true;

				// Auto-play main video or all videos on mobile
				if ($video.hasClass('main-video') || window.outerWidth < 768) {
					video.play().then(function() {
						// Show pause icon (video is playing)
						play_pause.eq(0).show();
						play_pause.eq(1).hide();
					}).catch(function(err) {
						console.warn('Auto-play was prevented:', err);
						// Show play icon (video is paused)
						play_pause.eq(0).hide();
						play_pause.eq(1).show();
					});
				} else {
					// Show play icon (video is paused)
					play_pause.eq(0).hide();
					play_pause.eq(1).show();
				}

				// Show muted icon (video starts muted)
				mute_unmute.eq(0).show();
				mute_unmute.eq(1).hide();
			});

			hls.on(Hls.Events.ERROR, function (event, data) {
				if (data.fatal) {
					switch (data.type) {
						case Hls.ErrorTypes.NETWORK_ERROR:
							console.error('Network error:', data);
							hls.startLoad();
							break;
						case Hls.ErrorTypes.MEDIA_ERROR:
							console.error('Media error:', data);
							hls.recoverMediaError();
							break;
						default:
							console.error('Fatal error:', data);
							hls.destroy();
							break;
					}
				}
			});

		} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = videoUrl;
			$video.on('loadedmetadata', function () {
				video.muted = true;
				video.loop = true;
				video.playsInline = true;
			});
		}
	});

	$('.video-play-pause').on('click', function () {
		const $btn = $(this);
		const $container = $btn.parents('.product-video');
		const $video = $container.find('video').get(0); // get raw video DOM element

		if (!$video) return;

		const $svgs = $btn.find('svg');

		if ($video.paused) {
			$video.play().then(() => {
				$svgs.eq(1).hide(); // play icon
				$svgs.eq(0).show(); // pause icon
			}).catch(err => {
				console.error('Play error:', err);
			});
		} else {
			$video.pause();
			$svgs.eq(1).show();  // play icon
			$svgs.eq(0).hide();  // pause icon
		}
	});

	// Keep every gallery play/pause icon in sync with its video (Cloudflare, Aprimo MP4 and HLS):
	// the icon follows the video's "playing" / "pause" events, so it is right however playback
	// starts or stops (autoplay, lazy load, click, loop, lightbox, browser pausing off-screen).
	$('.product-gallery-wrapper .video-play-pause').each(function () {
		const $svgs = $(this).find('svg');
		const video = $(this).parents('.product-video').find('video').get(0);

		bindPlayPauseIcon(video, function (playing) {
			$svgs.eq(0).toggle(playing);  // pause icon
			$svgs.eq(1).toggle(!playing); // play icon
		});
	});

	$('.video-mute-unmute').on('click', function () {
		const $btn = $(this);
		const $container = $btn.parents('.product-video');
		const $video = $container.find('video').get(0);

		if (!$video) return;

		const $svgs = $btn.find('svg');

		if ($video.muted || $video.volume === 0) {
			$video.muted = false;
			$video.volume = 1;
			$svgs.eq(0).hide(); // muted icon
			$svgs.eq(1).show(); // unmuted icon
		} else {
			$video.muted = true;
			$video.volume = 0;
			$svgs.eq(0).show(); // muted icon
			$svgs.eq(1).hide(); // unmuted icon
		}
	});

	const $stickyImage = $('.sticky-image');
	if ($stickyImage.length) {
		$stickyImage.css({
			position: 'sticky',
			top: '0',
			zIndex: '1'
		});
	}
});
